import { isValidElement } from 'react';
import { components } from 'react-select';

import { Typography } from '../../../../../Typography';
import { RenderWhen } from '../../../../../RenderWhen';
import { SelectOptionProps } from '../../SelectOption.types';
import { SelectContainerProps } from './SelectContainer.types';
import { useStyles } from './SelectContainer.styles';

export const SelectContainer = ({ children, className, ...rest }: SelectContainerProps) => {
  const { isFocused } = rest;
  const { label, errorMessage, isDisabled, required } =
    rest.selectProps as unknown as SelectOptionProps;

  const styles = useStyles({ errorMessage, isFocused });

  return (
    <components.SelectContainer css={styles.root} className={className} {...rest}>
      {label && (
        <div className="flex flex-row" css={styles.labelContainer} data-container-element="label">
          {isValidElement(label) ? label : <Typography>{label}</Typography>}

          <RenderWhen condition={Boolean(required)}>
            <Typography className="!text-error-400">*</Typography>
          </RenderWhen>
        </div>
      )}

      {children}

      {!isDisabled && errorMessage && (
        <div css={styles.errorMessageContainer}>
          <Typography>{errorMessage}</Typography>
        </div>
      )}
    </components.SelectContainer>
  );
};
